import React from "react";
import Button from "src/components/Button";
import Card from "src/components/Card";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";

interface SurveyCardProps extends Translation {
	children?: any;
}

const SurveyCard = ({ t }: SurveyCardProps) => {
	return (
		<Card className=" ">
			<div className="flex flex-col gap-4">
				<div>
					<strong>{t("title")}</strong>
					<p>{t("description")}</p>
				</div>
				<Button small href="https://s.surveyplanet.com/4u87100z">
					{t("button")}
					<small className="ml-2">
						<i className="fas fa-external-link"></i>
					</small>
				</Button>
			</div>
		</Card>
	);
};

SurveyCard.locale = {
	nl: {
		title: "Verdien €75 in 5 minuten!",
		description:
			"Wil jij binnen 5 minuten kans maken op een cadeaubon t.w.v. €75,-? Help ons met het invullen van een aantal vragen.",
		button: "Doe de survey",
	},
	en: {
		title: "Earn €75 in 5 minutes!",
		description:
			"Do you want to have a chance to win a €75 gift card within 5 minutes? Help us by answering a few questions.",
		button: "Take the survey",
	},
};

export default withTranslation(SurveyCard);
